import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  MultiSelect,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBuildingSkyscraper,
  IconCalendar,
  IconFileTypeCsv,
  IconSearch,
} from "@tabler/icons-react";
import Avvvatars from "avvvatars-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { repositoryMdm, repositoryPos } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { getMasterOrgSelect } from "../../../service/getSelectApi";
import { BASE_API_MDM } from "../../../config";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const TrackingReportKTBH = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [isCallFirst, setIsCallFirst] = useState<boolean>(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    FromDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.FromDate
        : new Date(
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              1
            ).getTime() +
              7 * 60 * 60 * 1000
          ).toISOString(),
    ToDate:
      _searchJson && checkedPinSearch
        ? _searchJson?.ToDate
        : new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    BranchIds: _searchJson && checkedPinSearch ? _searchJson?.BranchIds : [],
    ItemIds: _searchJson && checkedPinSearch ? _searchJson?.ItemIds : [],
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const [dataBranchSelect, setDataBranchSelect] = useState<ComboboxItem[]>([]);

  const [searchItem, setSearchItem] = useState<string>("");
  const [debounceSearchItem] = useDebouncedValue<string>(searchItem, 300);
  const [dataItemSelect, setDataItemSelect] = useState<ComboboxItem[]>([]);
  const [dataItemSelectTemp, setDataItemSelectTemp] = useState<ComboboxItem[]>(
    []
  );

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "maCt",
        header: "Mã chứng từ",
        Cell: ({ renderedCellValue }) => (
          <Badge color={renderedCellValue ? "green" : "red"} variant="dot">
            {renderedCellValue ? renderedCellValue : "Không xác định"}
          </Badge>
        ),
      },
      {
        accessorKey: "tenCn",
        header: "Chi nhánh",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {row.original.maCn} - {row.original.tenCn}
          </Text>
        ),
      },
      {
        accessorKey: "tenNguoiTiepNhan",
        header: "Tên người tiếp nhận",
        Cell: ({ renderedCellValue, row }) =>
          renderedCellValue !== null ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>
                {row.original.maNguoiTiepNhan} - {renderedCellValue}
              </Text>
            </Flex>
          ) : (
            <></>
          ),
      },
      { accessorKey: "serial", header: "Serial" },
      { accessorKey: "maSp", header: "Mã sản phẩm" },
      { accessorKey: "tenSp", header: "Tên sản phẩm" },
      {
        accessorKey: "hanBhHnc",
        header: "Hạn BH HNC",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "hanBhNcc",
        header: "Hạn BH NCC",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "khachHenGap",
        header: "Khách hẹn gặp",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue !== null ? (
            <Flex align={"center"} gap={"md"}>
              <Avvvatars
                value={`${renderedCellValue?.toString()?.normalize("NFD")}`}
              />
              <Text fw={500}>{renderedCellValue}</Text>
            </Flex>
          ) : (
            <></>
          ),
      },
      { accessorKey: "sdt", header: "Số điện thoại" },
      { accessorKey: "diaChi", header: "Địa chỉ" },
      {
        accessorKey: "ngayXuatBan",
        header: "Ngày xuất bán",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "maDh",
        header: "Mã đơn hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge color={"blue"} variant="dot">
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "ngayTiepNhanBh",
        header: "Ngày tiếp nhận BH",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "ngayXuatTra",
        header: "Ngày xuất trả",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "thoiGianHoanThanh",
        header: "Thời gian hoàn thành",
        size: 225,
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || Number(renderedCellValue) === 0 ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} ngày
            </Text>
          ) : (
            <></>
          ),
      },
    ],
    []
  );

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/WarrantyInfo/get-warranty-monitoring-report-for-ksnb?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };

  const exportDataExcel = async () => {
    open();
    try {
      let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const baseUrl = `/api/v1/WarrantyInfo/export-warranty-monitoring-report-for-ksnb${url}`;

      const _url = BASE_API_MDM + baseUrl;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        NotificationExtension.Fails("Export Excel thất bại !");
      } else {
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_theo_doi_KTBH.xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        NotificationExtension.Success("Export Excel thành công !");
      }
    } catch (error) {
      console.log(error);
    } finally {
      close();
    }
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      const data = res
        ?.filter((item) => item.text && item.value)
        ?.map((item) => ({
          label: `${item.att1} - ${item.text}`,
          value: String(item.value),
        }));

      setDataBranchSelect(data);
    }
  };

  const getDataItemCode = async () => {
    let url = `/api/v1/TblItem/get-list?Skip=0&Take=50`;

    if (debounceSearchItem.length > 0) {
      url += `&KeySearch=${debounceSearchItem}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data;
      const data = result
        ?.filter((item: any) => item.itemId && item.itemName && item.itemCode)
        ?.map((item: any) => ({
          label: `${item.itemCode} - ${item.itemName}`,
          value: String(item.itemId),
        }));
      setDataItemSelect(data);
      if (!isCallFirst) {
        setDataItemSelectTemp(data);
      }
      setIsCallFirst(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    getDataBranchSelect();
  }, []);

  useEffect(() => {
    if (isCallFirst) {
      if (searchItem.length > 3) {
        getDataItemCode();
      } else {
        setDataItemSelect(dataItemSelectTemp);
      }
    } else {
      getDataItemCode();
    }
  }, [debounceSearchItem, isCallFirst]);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningTrackingReportKTBH"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : { left: ["mrt-row-numbers"], right: ["action"] }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningTrackingReportKTBH",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (142.5 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableColumnFilters: false,
    enableSorting: false,
    enableColumnActions: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Button
            leftSection={<IconFileTypeCsv size={16} />}
            onClick={() => exportDataExcel()}
          >
            Export Excel
          </Button>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate ?? "")
                  : null
              }
              maxDate={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "FromDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.ToDate && search.ToDate?.length > 0
                  ? new Date(search.ToDate ?? "")
                  : null
              }
              minDate={
                search.FromDate && search.FromDate?.length > 0
                  ? new Date(search.FromDate)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "ToDate",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Chi nhánh"
              leftSection={<IconBuildingSkyscraper color="#15aabf" />}
              searchable
              clearable
              data={dataBranchSelect}
              value={
                search?.BranchIds && search?.BranchIds?.length > 0
                  ? search?.BranchIds
                  : []
              }
              onChange={(e) => {
                changeSearchValue(e ? e : [], "BranchIds", setSearch);
              }}
              nothingFoundMessage={"Không tìm thấy dữ liệu !"}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <MultiSelect
              placeholder="Sản phẩm"
              leftSection={<IconBarcode color="#15aabf" />}
              data={dataItemSelect}
              value={
                search?.ItemIds && search?.ItemIds?.length > 0
                  ? search?.ItemIds
                  : []
              }
              searchable
              searchValue={searchItem}
              onSearchChange={setSearchItem}
              clearable
              onChange={(e) =>
                changeSearchValue(e ? e : [], "ItemIds", setSearch)
              }
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default TrackingReportKTBH;
